import { render, staticRenderFns } from "./RemarkCard.vue?vue&type=template&id=421c5df0&scoped=true"
import script from "./RemarkCard.vue?vue&type=script&lang=js"
export * from "./RemarkCard.vue?vue&type=script&lang=js"
import style0 from "./RemarkCard.vue?vue&type=style&index=0&id=421c5df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c5df0",
  null
  
)

export default component.exports